import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@bwoty-web/ui-kit';
import {
  /* UI_SORT_ASCENDING as IconAsc, */
  UI_SORT_DESCENDING as IconDesc,
} from '@bwoty-web/ui-kit/icons';

const TableHeading = styled.th`
  display: none;
  padding: var(--space-400) 0;
  vertical-align: middle;
  text-align: left;

  button {
    padding: 0;
    border-bottom: 2px solid transparent;
    font: var(--font-body-m);
    text-align: left;
    text-transform: uppercase;
    &.asc,
    &.desc {
      border-bottom: 2px solid var(--color-dark-core-500);
    }
    :hover {
      border-bottom: 2px solid var(--color-dark-core-600);
    }
  }
  @media (min-width: 768px) {
    display: table-cell;
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
  }
`;

const StyledIcon = styled(Icon)`
  display: inline-block;
  margin: 0 3px -4px;
`;

const TableHeadings = ({
  labels: { tableLayout, teams },
  viewSettings,
  team,
  handleViewSettings,
}) => {
  const {
    sortBy: { order, column },
  } = viewSettings;

  let sortIcon;
  switch (order) {
    case 'desc':
      sortIcon = <StyledIcon size="xs" path={IconDesc} />;
      break;
    case 'asc':
    default:
      sortIcon = (
        <StyledIcon
          size="xs"
          path={{
            default:
              'M13.79,18.71a1,1,0,0,1,.07,1.42l-6,6.74,0,0a1.24,1.24,0,0,1-.23.17s-.06.05-.1.06a.93.93,0,0,1-.8,0s-.06,0-.1-.06a1.24,1.24,0,0,1-.23-.17s0,0,0,0l-6-6.74h0a1,1,0,0,1,1.5-1.35l4.29,4.79V5.77a1,1,0,0,1,2,0v17.8l4.29-4.79A1,1,0,0,1,13.79,18.71Zm5.6,6.51H17.88a1,1,0,1,0,0,2h1.51a1,1,0,1,0,0-2Zm2.52-5.11h-4a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Zm3-5.11H17.88a1,1,0,0,0,0,2h7.06a1,1,0,1,0,0-2Zm3-5.1H17.88a1,1,0,0,0,0,2H28a1,1,0,0,0,0-2Zm3-5.11H17.88a1,1,0,0,0,0,2H31a1,1,0,1,0,0-2Z',
          }}
        />
      );
      break;
  }

  const updateViewSettings = (e) => {
    const { id } = e.target;
    handleViewSettings((prevState) => {
      function setOrder() {
        if (column !== id) {
          return order;
        }
        return order === 'asc' ? 'desc' : 'asc';
      }
      return {
        ...prevState,
        sortBy: {
          column: id,
          order: setOrder(),
        },
      };
    });
  };

  return (
    <tr>
      <TableHeading>
        <button
          id="matchDate"
          className={column === 'matchDate' ? order : ''}
          onClick={updateViewSettings}
          type="button"
        >
          {tableLayout.matchDate}
        </button>
        {column === 'matchDate' && sortIcon}
      </TableHeading>
      <TableHeading>
        <button
          id="opponentName"
          className={column === 'opponentName' ? order : ''}
          onClick={updateViewSettings}
          type="button"
        >
          {tableLayout.opponent}
        </button>
        {column === 'opponentName' && sortIcon}
      </TableHeading>
      <TableHeading>
        <button
          id="basePackage"
          className={column === 'basePackage' ? order : ''}
          onClick={updateViewSettings}
          type="button"
        >
          {teams[team].basePackage || tableLayout.basePackage}
        </button>
        {column === 'basePackage' && sortIcon}
      </TableHeading>
      <TableHeading>
        <button
          id="fullPackage"
          className={column === 'fullPackage' ? order : ''}
          onClick={updateViewSettings}
          type="button"
        >
          {teams[team].fullPackage || tableLayout.fullPackage}
        </button>
        {column === 'fullPackage' && sortIcon}
      </TableHeading>
    </tr>
  );
};

TableHeadings.propTypes = {
  labels: PropTypes.shape({
    tableLayout: PropTypes.shape({
      matchDate: PropTypes.string,
      opponent: PropTypes.string,
      opponentName: PropTypes.string,
      basePackage: PropTypes.string,
      fullPackage: PropTypes.string,
    }),
  }),
  team: PropTypes.string,
  viewSettings: PropTypes.shape({
    sortBy: PropTypes.shape({
      order: PropTypes.string,
      column: PropTypes.string,
    }),
  }),
  handleViewSettings: PropTypes.func,
}.isRequired;

TableHeading.defaultProps = {
  labels: null,
  viewSettings: null,
  team: undefined,
  handleViewSettings: null,
};

export default TableHeadings;
